const initialState = () => {
    return {
        ticketCounter: 0,
        invoiceTicketCounter: 0,
        officeID: null,
    }
}

export default initialState
